import { render, staticRenderFns } from "./ForgotPasswordScreenForm.vue?vue&type=template&id=7e4e2da0&scoped=true&"
import script from "./ForgotPasswordScreenForm.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordScreenForm.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordScreenForm.vue?vue&type=style&index=0&id=7e4e2da0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4e2da0",
  null
  
)

export default component.exports